import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
const images = require.context('../../images/logotypes', true);

const List = props => {

    return (
        <div className={classNames({
            'search-result__list': true,
            'search-result__list--is-loading': props.isLoading
        })}>
            {props.result && props.result.map((unit, i) => {
                let src = null;
                try {
                    src = images(`./${unit.ChainCode}.png`);

                } catch {
                    src = null;
                }
                
                return (
                    <Link key={`sresult${i}`}
                       to={{
                           pathname:`/unit/${unit.DelfiId}`,
                           state: { from: props.location } 
                       }} 
                       onMouseEnter={() => props.handleMouseOverOut(unit.id)} 
                       onMouseLeave={() => props.handleMouseOverOut(null)} 
                       className="search-result__item">
                        <header className="search-result__item-header">
                            <h2 className="search-result__heading">{unit.UnitName}</h2>
                            <h3 className="search-result__subheading">Delfi-ID {unit.DelfiId}</h3>
                            <div className="search-result__logo">
                                {src &&
                                    <img src={src} alt={unit.UnitName} />
                                }
                            </div>
                        </header>
                        <div className="search-result__data">
                            <div className="search-result__data-col">
                                <h3>Typ</h3>
                                <p>{unit.TypeName}</p>
                            </div>
                            {unit.VisitingAddress &&
                                <>
                                    <div className="search-result__data-col">
                                        <h3>Adress</h3>
                                        <p>{unit.VisitingAddress.Address}</p>
                                    </div>
                                    <div className="search-result__data-col">
                                        <h3>Ort</h3>
                                        <p>{unit.VisitingAddress.City}</p>
                                    </div>
                                </>
                            }
                            {unit.Telephone &&
                                <div className="search-result__data-col">
                                    <h3>Telefon</h3>
                                    <p>{unit.Telephone}</p>
                                </div>
                            }
                        </div>
                    </Link>
                );
            })}            
        </div>
    );
   
};

export default List;